<script>
const fetchImage = (async () => {
		const response = await fetch('https://raw.githubusercontent.com/yashpulse/nilshailliimages/main/ppt/ppt.json')
    return await response.json()
	})()
    
</script>

<style>
    img{
        display: block;
        width: 100%;
        margin: 0 !important;
        padding: 0 !important;
        border-bottom: 1px solid grey;
    }
</style>

{#await fetchImage}
	<p>Loading ...</p>
{:then data}
{#each data as imgs}
	<img src={imgs} />
    {/each}
{:catch error}
	<p>Please Refresh !!!</p>
{/await}